<app-sub-navbar></app-sub-navbar>

<!-- Content -->

<section class="container-fluid my-md-4 bd-layout">
  <aside class="bd-sidebar">
    <nav class="collapse bd-links" id="filterz" aria-label="filterz">
      <ul class="list-unstyled mb-0 py-3 pt-md-1">
        <li class="mb-1">
          <a routerLink="/profile" class="btn d-inline-flex align-items-center rounded">
            Profile
          </a>
        </li>

        <li class="mb-1">
          <a routerLink="/downloads" class="btn d-inline-flex align-items-center rounded">
            Downloads
          </a>
        </li>

        <li class="mb-1">
          <a routerLink="/favorites" class="btn d-inline-flex align-items-center rounded">
            Favorites
          </a>
        </li>

        <li class="mb-1">
          <a routerLink="/subscription" class="btn d-inline-flex align-items-center rounded">
            Subscription
          </a>
        </li>
      </ul>
    </nav>
  </aside>

  <div class="container-fluid overflow-hidden">
    <div class="row">
      <div class="pad-bottom justify-content-between d-flex">
        <h3 class="fw-bold">Downloads</h3>

        <button class="btn bd-sidebar-toggle d-md-none py-0 px-1 ms-3 order-3 collapsed" type="button"
          data-bs-toggle="collapse" data-bs-target="#filterz" aria-controls="filterz" aria-expanded="false"
          aria-label="Toggle docs navigation">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="bi bi-expand" viewBox="0 0 16 16">
            <title>Expand</title>
            <path fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z" />
          </svg>

          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="bi bi-collapse" viewBox="0 0 16 16">
            <title>Collapse</title>
            <path fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707l-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z" />
          </svg>
        </button>
      </div>
    </div>

    <div class="py-3 justify-content-center">
      <div class="col-md-12 col-lg-11">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" style="white-space: nowrap">Details</th>
                <th scope="col" style="white-space: nowrap">Download date</th>
                <th scope="col" style="white-space: nowrap">License</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <!-- 🔹 Skeleton Loader Rows -->
              <ng-container *ngIf="loader">
                <tr *ngFor="let i of skeletonArray">
                  <td>
                    <div class="d-flex align-items-center gap-2">
                      <div class="skeleton skeleton-thumb"></div>
                      <div class="skeleton skeleton-text"></div>
                    </div>
                  </td>

                  <td class="align-middle">
                    <div class="skeleton skeleton-date"></div>
                  </td>

                  <td class="align-middle">
                    <div class="skeleton skeleton-btn"></div>
                  </td>

                  <td></td>
                </tr>
              </ng-container>


              <tr *ngFor="let data of visibleDownloads" [hidden]="loader">
                <td>
                  <a class="download-details" [routerLink]="'/illustration/' + data.slug">
                    <div class="d-flex flex-column flex-md-row justify-content-start gap-2">
                      <img *ngIf="getSEOImage(data?.previewUrl || data.jpeg || data.png)"
                        [src]="getSEOImage(data?.previewUrl || data.jpeg || data.png)" [alt]="data.title"
                        class="img-radius-sm thumbnail-img img-fluid skeleton--thumbnail"
                        [class.skeleton--image]="!data.imageLoad" [class.image-loaded]="data.imageLoad"
                        (load)="data.imageLoad = true" />
                      <span class="text-ellipse hide-sm my-auto">{{ data.title }}</span>

                      <!-- &nbsp; <span class="hide-sm text-box"></span> -->
                    </div>
                  </a>
                </td>
                <td class="align-middle">
                  {{data.downloadedDate}}
                </td>
                <td class="align-middle">
                  <button data-bs-toggle="modal" data-bs-target="#licenseModal" class="btn btn-ib-light"
                    (click)="isPremium = data.isPremium" [attr.aria-label]="'View License for ' + data.title">
                    License
                  </button>
                </td>
              </tr>
              <tr class="border-0" *ngIf="!loader && visibleDownloads.length === 0">
                <td class="border-0">No data found</td>
              </tr>
            </tbody>
          </table>

          <!-- 🔹 Load More Button -->
          <div class="d-flex justify-content-center my-3" *ngIf="!loader && hasMoreData">
            <button [disabled]="isLoadingMore"
              class="btn fw-semi btn-outline-black rounded-3 px-4 py-2 d-flex align-items-center gap-2"
              (click)="loadMore()">
              <!-- Spinner -->
              <span *ngIf="isLoadingMore" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>

              <!-- Text -->
              <span>{{ isLoadingMore ? 'Loading...' : 'Load more' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- License, show this modal -->

<div #licenseModal class="modal fade" id="licenseModal" tabindex="-1" aria-labelledby="licenseModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="licenseModalLabel">License summary</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="py-2 col-md-12 mx-auto">
              <div class="license-features">
                <div class="pro" *ngIf="isPremium">
                  <h2 class="fs-4 fw-bold mb-3">Pro License: All Free Benefits and Plus Extra Rights</h2>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp;
                    High-resolution exclusive assets
                  </p>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp;
                    Use in paid ads, packaging, and products for sale
                  </p>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp;
                    Extended commercial rights
                  </p>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp;
                    No attribution required
                  </p>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp;
                    Priority for professional use cases
                  </p>
                </div> <br>

                <div class="free" *ngIf="!isPremium">
                  <h2 class="fs-4 fw-bold mb-2">Free License Usage Rights</h2>

                  <p class="attribution text-secondary mb-4">You may use our illustrations for free in both personal and
                    commercial
                    projects, as long as proper attribution is provided.

                    You can include an attribution line such as:
                    <a href="#" (click)="copyAttribution($event)">Designed by Illusbook</a>
                    on your final product or design, whether digital or physical.
                  </p>


                  <h3 class="fs-5 fw-bold mb-3">This license allows you to:</h3>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp;
                    For commercial and personal projects
                  </p>
                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp;
                    On digital or printed media
                  </p>
                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp;
                    For an unlimited number of times, continuously
                  </p>
                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp;
                    From anywhere in the world
                  </p>
                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp;
                    With modifications or to create derivative works
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>